import { createSelector } from 'reselect'

import { PLAN_TYPES } from 'containers/App/constants'
import { selectActualLicenses, selectIsFirstCampaignCreated } from 'containers/App/selectors'
import {
  createWizardCampaignSelector,
  PARTICIPANTS_ALL_CATEGORY,
} from 'containers/AwarenessCenter/constants'

import { selectParticipants } from '../selectors'

const _ = require('lodash')

const selfPath = (state) => createWizardCampaignSelector(state).setupStep

export const selectError = (state) => selfPath(state).error
export const selectParticipantsInfoToInclude = (state) =>
  selfPath(state).data.participantsInfoToInclude
export const selectParticipantsInfoLoader = (state) => selfPath(state).data.loader
export const selectSimulationSendingRemindersCount = (state) =>
  selfPath(state).sendingRemindersCount

export const selectParticipantsInfoToExclude = createSelector(
  selectParticipants,
  selectParticipantsInfoToInclude,
  (participants, participantsInfoToInclude) => {
    const selectedParticipants = participants.included
    const participantsToExclude = _.cloneDeep(participantsInfoToInclude) // deep-clone to not change original
    // options from exclude
    const categoriesToAvoid = [PARTICIPANTS_ALL_CATEGORY]
    categoriesToAvoid.forEach((i) => delete participantsToExclude[i])
    // iterate through included prticipants
    Object.keys(selectedParticipants)
      .filter((i) => !categoriesToAvoid.includes(i))
      .map((category) => {
        selectedParticipants[category].map((field) => {
          if (Array.isArray(participantsToExclude[category])) {
            // children are in array
            participantsToExclude[category] = participantsToExclude[category].filter(
              (a) => a !== field
            )
          } else if (!Array.isArray(participantsToExclude) && participantsToExclude[category]) {
            delete participantsToExclude[category][field]
          }
        })
      })

    return participantsToExclude
  }
)

export const selectQLParticipantGroups = (state) => {
  const data = selfPath(state).qlData
  if (!data.participantGroups) return []
  else return data.participantGroups
}
export const selectQLError = (state) => selfPath(state).qlError
export const selectQLLoader = (state) => selfPath(state).qlLoader
export const selectQLGeneratingLoader = (state) => selfPath(state).qlGeneratingLoader
export const selectQLGeneratedCampaignId = (state) => selfPath(state).qlGeneratedCampaignId
export const selectIsQuickKickoff = (state) =>
  !selectIsFirstCampaignCreated(state) && selectActualLicenses(state).plan === PLAN_TYPES.STARTER
export const selectIsLocalNotifyManagerEnabled = (state) =>
  selfPath(state).isLocalNotifyManagerEnabled
export const selectIsLocalNotifyManagerEnabledWasChanged = (state) =>
  selfPath(state).isLocalNotifyManagerEnabledWasChanged
